import { render, staticRenderFns } from "./coPlan.vue?vue&type=template&id=3c0b08b0&scoped=true"
import script from "./coPlan.vue?vue&type=script&lang=js"
export * from "./coPlan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c0b08b0",
  null
  
)

export default component.exports